import React from 'react';
import ThemeFilter from './shared/ThemeFilter';
import ItemList from './shared/ItemList';
import ItemsListView from './shared/ItemsListView';
import BenefitThumbView from './BenefitThumbView';
import ItemView from './shared/ItemView';
import JustLookingModalBox from './shared/JustLookingModalBox';
import BenefitSearch from './SearchBenefits';
import ViewToggleTabs from './shared/ViewToggleTabs';
import WhiteLabel from './shared/WhiteLabel';
import EmployeeFooter from '../EmployeeFooter';
import LeavePlanTitle from '../dashboard/LeavePlanTitle'

class LeaveBenefits extends React.Component {
  constructor(props) {
    super(props)

    this.infoTexts = [
      "Add Voluntary Tasks to your LeavePlan",
      "Set reminders for important tasks",
      "Enable sharing of key LeavePlan details with your Manager and HR (you share when you're ready)"
    ]

    this.state = {
      leave_benefits: props.data,
      viewMode: false,
      activeList: '',
      activeBenefit: '',
      activate_leave_plan_modal: false,
      theme_tab: true,
      themes: this.themeIds()
    }
  }

  componentDidMount() {
    const location = window.location
    if (location.hash) {
      const benefit = this.state.leave_benefits.filter((item) => {
        return Number(item.leave_item_id) === Number(location.hash.substring(1))
      })[0]
      window.history.replaceState({}, 'LeaveLogic', '/leave_plan_benefits')
      if (benefit) {
        $.getJSON(`/leave_plan_benefits/${benefit.id}/fetch_details`, (data) => {
          gon.company_variables  = {...gon.company_variables, ...data.statutory_substitutions_options}
          this.setActiveClass(benefit, data.description)
        })
      }
    }
  }

  themeIds() {
    return this.props.themes.map((theme) => {
      return theme.id
    })
  }

  handleChange(e) {
    e.preventDefault()
    const searchString = e.target.value
    $.ajax({
      url: '/leave_plan_benefits',
      method: 'GET',
      dataType: 'JSON',
      data: { q: searchString },
      success: (leaveBenefits) => {
        this.setState({leave_benefits: leaveBenefits})
      }
    })
  }

  searchBenefits(benefits) {
    this.setState({
      viewMode: false,
      leave_benefits: benefits,
      themes: this.getThemeIds(benefits)
    })
  }

  handleBack(state) {
    window.history.pushState(state, state.benefit.title, "#" + state.benefit.leave_item_id)
    window.onpopstate = (event) => {
      const state = window.history.state
      const location = window.location
      if (location.hash) {
        this.setState({
          viewMode: true,
          activeBenefit: state.benefit,
          activeList: state.benefit.id,
          description: state.description
        })
      } else {
        this.setState({
          viewMode: false,
          activeBenefit: '',
          activeList: '',
          activate_leave_plan_modal: false
        })
      }
    }
  }

  setActiveClass(benefit, description) {
    if (Number( window.location.hash.substring(1) ) !== Number( benefit.leave_item_id)) {
      this.handleBack({
        benefit: benefit,
        description: description
      })
    }
    $(window).scrollTop(0)
    this.setState({
      viewMode: true,
      activeBenefit: benefit,
      activeList: benefit.id,
      description: description
    })
  }

  updateRecord(record) {
    this.setState({activeBenefit: record})
    let leave_benefits = this.state.leave_benefits
    let index = ''
    $.each(leave_benefits, (benefit, ind) => {
      if (benefit.id === parseInt(record.id)) {
        index = ind
        return false
      }
    })
    leave_benefits[index] = record
    this.setState({leave_benefits: leave_benefits})
  }

  getAllData() {
    PubSub.publish('clearInput:onClick')
    this.getInitialData()
    if (Number(window.location.hash.substring(1)) !== "") {
      window.history.pushState({
        leave_benefits: this.props.data,
        viewMode: false,
        activeList: '',
        activeBenefit: '',
        activate_leave_plan_modal: false
      }, "All Benefits", "#")
    }
  }

  getInitialData() {
    $.getJSON("/leave_plan_benefits", (data) => {
      this.setState({leave_benefits: data})
    })
    this.setState({
      viewMode: false,
      activeBenefit: '',
      activeList: '',
      themes: this.themeIds()
    })
  }

  handleCheck(record) {
    let leave_benefits = this.state.leave_benefits
    let activeBenefit = this.state.activeBenefit
    const index = leave_benefits.indexOf(activeBenefit)
    activeBenefit.timeline_items.map((item) => {
      if (item.id == parseInt(record.data.timeline_id)) {
        item.check_status = record.data.check_status
      }
      return item
    })
    leave_benefits[index] = activeBenefit
    this.setState({
      activeBenefit: activeBenefit,
      leave_benefits: leave_benefits
    })
  }

  onHelpfulCheck(data) {
    let benefits = this.state.leave_benefits
    $.each(benefits, (i, benefit) => {
      $.each(benefit.timeline_items, (j, task) => {
        if (data.item_id === task.timeline_id) {
          task.helpful = data.helpful
          return false
        }
      })
    })
    this.setState({leave_benefits: benefits})
  }

  handleJustLookingClick(value) {
    this.setState({activate_leave_plan_modal: value})
  }

  onHelpfulCheckFromOutside(data) {
    let benefits = this.state.leave_benefits
    $.each(benefits, (i, benefit) => {
      if (data.item_id === benefit.id) {
        benefit.item.helpful = data.helpful
        return false
      }
    })
    this.setState({leave_benefits: benefits    })
  }

  handleTabChange(tab) {
    $(window).scrollTop(0)
    this.setState({viewMode: false})
    if (tab === 'theme') {
      this.setState({theme_tab: true})
    } else if (tab === 'list') {
      this.setState({theme_tab: false})
    }
  }

  handleFilterChange(checked, theme_id) {
    let themes = this.state.themes
    const id = parseInt(theme_id)
    if (checked) {
      themes.push(id)
    } else {
      const found = $.inArray(id, themes)
      themes.splice(found, 1)
    }
    this.setState({themes: themes})
  }

  getThemeIds(items) {
    return items.filter((item) => {
      return item.theme_id !== null
    }).map((item) => {
      return item.theme_id
    })
  }


  handleBackClick() {
    history.back()
  }

  allItemsNotSelected() {
    return (this.state.leave_benefits.length !== this.props.data.length) || (this.state.themes.length !== this.props.themes.length)
  }

  renderSidebar() {
    if (this.state.theme_tab) {
      return (
        <ThemeFilter
          data={this.props.themes}
          themes={this.state.themes}
          handleFilterChange={this.handleFilterChange.bind(this)}
          allItemsNotSelected={this.allItemsNotSelected.bind(this)}
          selectAllItems={this.getInitialData.bind(this)}
        />
      )
    } else {
      return (
        <div>
          <ul className='sidebar-nav'>
            {
              this.state.leave_benefits.map((benefit, i) => {
                return (
                  <ItemList
                    key={i}
                    data={benefit}
                    handleOnClick={this.setActiveClass.bind(this)}
                    activeList={this.state.activeList}
                    controller_path='leave_plan_benefits'
                  />
                )
              })
            }
          </ul>
        </div>
      )
    }
  }

  renderItems() {
    if (this.state.theme_tab) {
      return (
        <BenefitThumbView
          leave_benefits={this.state.leave_benefits}
          themes={this.state.themes}
          handleOnClick={this.setActiveClass.bind(this)}
        />
      )
    } else {
      return (
        <ItemsListView
          data={this.state.leave_benefits}
          handleOnClick={this.setActiveClass.bind(this)}
          item_link='leave_plan_benefits'
        />
      )

    }
  }

  renderBody() {
    if (this.state.viewMode) {
      return (
        <ItemView
          data={this.state.activeBenefit}
          updateRecord={this.updateRecord.bind(this)}
          associationUrl='leave_plan_benefits/add_to_leave_plan'
          handleCheck={this.handleCheck.bind(this)}
          description={this.state.description}
          onHelpfulCheck={this.onHelpfulCheck.bind(this)}
          just_looking={this.props.just_looking}
          handleJustLookingClick={this.handleJustLookingClick.bind(this)}
          onHelpfulCheckFromOutside={this.onHelpfulCheckFromOutside.bind(this)}
          handleBackClick={this.handleBackClick.bind(this)}
          isLeavePlanPartner={this.props.isLeavePlanPartner}
        />
      )
    }
    else {
      return (
        <div className='row'>
          <div className='col-md-12 content-header'>
            <h2>
              Benefits
            </h2>
            <div className="pull-right benefit-review">
              You have <span className="number-of-benefits">{this.props.data.length}</span> benefits to review
            </div>
            <div className='leave-plan-item-summary'>
              Below are benefits that may be available to you. Please take the time to explore and identify the items that may apply to your situation and needs.
            </div>
          </div>
          { this.renderItems() }
        </div>
      )
    }
  }

  renderJustLookingModal() {
    if (this.state.activate_leave_plan_modal) {
      return (
        <JustLookingModalBox
          handleJustLookingClose={this.handleJustLookingClick.bind(this)}
          infoTexts={this.infoTexts.bind(this)}
          buttons={{
            cancel: 'Later',
            confirm: 'Activate Now'
          }}
        />
      )
    }
  }

  render() {
    return(
        <div>
          <div id='sidebar-wrapper'>
            <div id='sidebar-content'>
              <div className='sidebar-elements'>
                <BenefitSearch
                  handleOnSubmit={this.searchBenefits.bind(this)}
                  handleOnReset={this.getAllData.bind(this)}
                />
                <ViewToggleTabs
                  theme_tab={this.state.theme_tab}
                  handleTabChange={this.handleTabChange.bind(this)}
                />
                { this.renderSidebar() }
              </div>
              <WhiteLabel />
            </div>
          </div>
          <div id='page-content-wrapper'>
            <div className='page-content'>
              <div className='container-fluid'>
                <LeavePlanTitle
                  title= {this.props.leave_plan_title}
                  leave_plan_id= {this.props.leave_plan_id}
                />
                { this.renderBody() }
              </div>
            </div>
            <EmployeeFooter disclaimerText={this.props.disclaimer_text} />
          </div>
          { this.renderJustLookingModal() }
        </div>)
  }
}

export default LeaveBenefits
